"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _Icons = require("../../atoms/Icons");

require("./Breadcrumb.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Breadcrumb(props) {
  var activeRoute = props.activeRoute;
  var general = activeRoute.general,
      specific = activeRoute.specific,
      back = activeRoute.back,
      onBack = activeRoute.onBack;
  var history = (0, _reactRouter.useHistory)();
  var handleBack = (0, _react.useCallback)(function () {
    if (onBack) onBack(history);else history.goBack();
  }, [history, onBack]);
  if (!general && !specific) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full"
  }, back && /*#__PURE__*/_react.default.createElement("span", {
    className: "Breadcrumb__back cursor-pointer inline-block mr-1",
    onClick: handleBack,
    onKeyDown: handleBack,
    tabIndex: "0",
    role: "button"
  }, /*#__PURE__*/_react.default.createElement(_Icons.ChevronLeft, {
    width: "2.20rem",
    height: "2.20rem"
  })), general && /*#__PURE__*/_react.default.createElement("span", {
    className: "text-default-blue font-extrabold inline-block"
  }, general.label, ' '), specific && specific.label && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "|", /*#__PURE__*/_react.default.createElement("span", {
    className: "font-normal"
  }, " ", specific.label, " ")));
}

Breadcrumb.propTypes = {
  activeRoute: _propTypes.default.shape({
    general: _propTypes.default.shape({
      label: _propTypes.default.string
    }),
    specific: _propTypes.default.shape({
      label: _propTypes.default.string
    }),
    back: _propTypes.default.bool,
    onBack: _propTypes.default.func
  })
};
Breadcrumb.defaultProps = {
  activeRoute: {
    general: null,
    specific: null,
    back: false
  }
};
var _default = Breadcrumb;
exports.default = _default;